import React from 'react'

export default function LoadingSection() {
    return <div className="loading-spinner"><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i></div>
}
